import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	formControl: {
		width: "100%",
	},
}));
